module.exports = __webpack_public_path__ + "img/ejemplo-5.fa94506b.jpg";